<template>
  <div id="base-delete-button">
    <v-btn color="red" dark v-if="permissionDelete" v-on="$listeners">
      <slot>Delete</slot>
      <!-- default slot content: "Delete" -->
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'base-delete-button',
  computed: {
    permissionDelete() {
      return this.$store.getters['Permission/getAll'].delete
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/BaseDeleteButton.vue